import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol viewBox=\"0 0 16 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\">\n<path d=\"M8 9L16 0H0L8 9Z\" fill=\"#206FED\" fill-opacity=\"0.39\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol